<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <gg-loading :loading="loading">
            <gg-card>
              <gg-card-header>
                Bandwidth History
                <gg-btn secondary :loading="graphs_loading" @click="updateGraphs" class="float-right">
                  Refresh
                </gg-btn>
              </gg-card-header>
              <gg-card-text>
                <v-img :src="bandwidthGraph" max-height="200" contain />
              </gg-card-text>
            </gg-card>
          </gg-loading>
        </v-col>
        <v-col cols="12">
          <gg-loading :loading="loading">
            <gg-card>
              <gg-card-header>
                Load History
                <gg-btn secondary :loading="graphs_loading" @click="updateGraphs" class="float-right">
                  Refresh
                </gg-btn>
              </gg-card-header>
              <gg-card-text>
                <v-img :src="loadGraph" max-height="200" contain />
              </gg-card-text>
            </gg-card>
          </gg-loading>
        </v-col>
        <v-col cols="12">
          <gg-loading :loading="loading">
            <gg-card>
              <gg-card-header>
                Memory History
                <gg-btn secondary :loading="graphs_loading" @click="updateGraphs" class="float-right">
                  Refresh
                </gg-btn>
              </gg-card-header>
              <gg-card-text>
                <v-img :src="memoryGraph" max-height="200" contain />
              </gg-card-text>
            </gg-card>
          </gg-loading>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DServerGraphs',
  props: {
    loading: {
      type: Boolean,
    }
  },
  data: () => ({
    graphs_loading: false
  }),
  methods: {
    ...mapActions(['getHostingDetail', 'reportError', 'reportSuccess']),
    async updateGraphs () {
      this.graphs_loading = true
      try {
        await this.getHostingDetail()
        this.reportSuccess('All graphs updated')
        this.graphs_loading = false
      } catch (e) {
        this.graphs_loading = false
        this.reportError(e)
      }
    }
  },
  computed: {
    ...mapGetters(['hosting_detail']),
    bandwidthGraph () {
      if (this.hosting_detail !== null) {
        if (this.hosting_detail.graph_traffic !== '') {
          return this.hosting_detail.graph_traffic
        }
      } else {
        return '/static/img/amui/no-image.svg'
      }
      return '/static/img/amui/no-image.svg'
    },
    loadGraph () {
      if (this.hosting_detail !== null) {
        if (this.hosting_detail.graph_load !== '') {
          return this.hosting_detail.graph_load
        }
      } else {
        return '/static/img/amui/no-image.svg'
      }
      return '/static/img/amui/no-image.svg'
    },
    memoryGraph () {
      if (this.hosting_detail !== null) {
        if (this.hosting_detail.graph_memory !== '') {
          return this.hosting_detail.graph_memory
        }
      } else {
        return '/static/img/amui/no-image.svg'
      }
      return '/static/img/amui/no-image.svg'
    }
  }
}
</script>

<style lang="scss">
  .align-center {
    text-align: center;
  }
</style>
